//sellpoints
export const sellpointGetters = {
    // All sellpoints
    allSellpoints: (state, getters) => {
      return state.sellpoints
    },

    // Get Sellpoint by ID
    sellpointById: (state, getters) => id => {
      if (getters.allSellpoints.length > 0) {
        return getters.allSellpoints.filter(p => p._id === id)[0]
      } else {
        return state.sellpoint
      }
    },
}

//products
export const productGetters = {
  // All products
  allProducts: (state, getters) => {
      return state.products
    },
  // Get Product by ID
  productById: (state, getters) => id => {
    if (getters.allProducts.length > 0) {
      return getters.allProducts.filter(p => p._id === id)[0]
    } else {
      return state.product
    }
  },
 }

 //cart
 export const cartGetters = {
   //return cart
   cartProducts: state => {
    return state.added.map(({ id, quantity }) => {
      const product_item = state.all.find(p => p._id === id)

      return {
        name: product.name,
        price: product.price,
        quantity
      }
    })
  }
 }
  


// WEBPACK FOOTER //
// ./src/store/getters.js